<template>
  <div class="grid m-2">
    <div class="col-12">
      <Card>
        <template #title="">
          <div class="flex justify-content-between">
            จัดการ User
            <Button
              label="สร้างใหม่"
              class="p-button-success"
              icon="pi pi-plus"
              @click="onNew"
            ></Button>
          </div>
        </template>
        <template #content="">
          <DataTable
            :value="filteredUsers"
            responsiveLayout="scroll"
            filterDisplay="menu"
            dataKey="userId"
            scrollable
            scrollHeight="60vh"
            class="p-datatable-sm"
            :loading="isLoading"
          >
            <template #header="">
              <span class="p-float-label">
                <InputText
                  id="searchString"
                  v-model="searchString"
                  class="p-inputtext-sm"
                ></InputText>
                <label for="searchString">ค้นหา</label>
              </span>
            </template>
            <Column field="userId" header="User Id" sortable></Column>
            <Column field="adUser" header="AD User" sortable></Column>
            <Column field="name" header="Name" sortable></Column>
            <Column field="deliverAuthority" header="สิทธิการใช้งาน Mobile App">
              <template #body="props">
                <i class="pi pi-check" v-if="props.data.deliverAuthority"></i>
                <i class="pi pi-times" v-else></i>
              </template>
            </Column>
            <Column field="reportAuthority" header="สิทธิการดูรายงาน" sortable>
              <template #body="props">
                <i class="pi pi-check" v-if="props.data.reportAuthority"></i>
                <i class="pi pi-times" v-else></i>
              </template>
            </Column>
            <Column
              field="salesOfficeAuthority"
              header="สำนักงานขายที่มีสิทธิ"
              sortable
            >
              <template #body="props">
                <span v-if="props.data.salesOfficeAuthority?.length <= 20">{{
                  props.data.salesOfficeAuthority
                }}</span>
                <span
                  v-else
                  v-tooltip="
                    `${props.data.salesOfficeAuthority?.replaceAll(',', ', ')}`
                  "
                  >{{
                    `${props.data.salesOfficeAuthority.substring(0, 20)}...`
                  }}</span
                >
              </template>
            </Column>
            <Column field="adminAuthority" header="สิทธิ Admin" sortable>
              <template #body="props">
                <i class="pi pi-check" v-if="props.data.adminAuthority"></i>
                <i class="pi pi-times" v-else></i>
              </template>
            </Column>
            <Column headerStyle="width:4rem">
              <template #body="props">
                <Button
                  icon="pi pi-pencil"
                  class="p-button-rounded p-button-warning"
                  @click="onEdit(props.data)"
                ></Button>
                <!-- <Button
                  icon="pi pi-trash"
                  class="p-button-rounded p-button-danger ml-2"
                  @click="onDelete(props.data)"
                ></Button> -->
              </template>
            </Column>
            <template #empty=""> ไม่พบข้อมูล </template>
          </DataTable>
        </template>
      </Card>
    </div>
  </div>

  <Dialog v-model:visible="showPopup" header="ข้อมูล User" modal>
    <div class="grid formgrid">
      <div class="col-12 md:col-6 field p-fluid">
        <label for="userId">User Id (84xxxxxx)</label>
        <InputText
          id="userId"
          v-model="user.userId"
          :readonly="editMode"
        ></InputText>
      </div>
      <div class="col-12 md:col-6 field p-fluid">
        <label for="adUser">Ad User</label>
        <InputText id="adUser" v-model="user.adUser"></InputText>
      </div>
      <div class="col-12 field p-fluid">
        <label for="name">Name</label>
        <InputText id="name" v-model="user.name"></InputText>
      </div>
      <div class="col-12 md:col-4 field-checkbox">
        <Checkbox
          id="deliver"
          binary
          v-model="user.deliverAuthority"
        ></Checkbox>
        <label for="deliver">สิทธิการใช้งาน POD</label>
      </div>
      <div class="col-12 md:col-4 field-checkbox">
        <Checkbox
          id="reportAuth"
          binary
          v-model="user.reportAuthority"
        ></Checkbox>
        <label for="reportAuth">สิทธิการดูรายงาน</label>
      </div>
      <div
        class="col-12 md:col-4 field-checkbox"
        v-tooltip.bottom="`สามารถแก้ไขผู้ใช้งานได้`"
      >
        <Checkbox id="admin" binary v-model="user.adminAuthority"></Checkbox>
        <label for="admin">สิทธิ Admin</label>
      </div>
      <div class="col-12 p-fluid field">
        <label for="salesoffice">ระบุ Sales Office ที่สามารถดูรายงานได้</label>
        <Textarea
          id="salesoffice"
          v-model="user.salesOfficeAuthority"
          v-tooltip.bottom="
            `ระบุ Sales office ที่สามารถดูรายงานได้ คั่นด้วย , เช่น 9201,9202,9203 เป็นต้น`
          "
        ></Textarea>
      </div>
    </div>
    <template #footer="">
      <Button
        icon="pi pi-check"
        label="ตกลง"
        class="p-button-success"
        @click="onSubmit"
      ></Button>
      <Button
        icon="pi pi-times"
        @click="showPopup = false"
        label="ยกเลิก"
        class="p-button-danger"
      ></Button>
    </template>
  </Dialog>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, ref } from "vue";
import {
  GetUserResponse,
  UpsertUserRequest,
  UpsertUserResponse,
  User,
} from "@/types";
import { usePlugin } from "@/plugins";
import Fuse from "fuse.js";
import { useSessionStorage } from "@vueuse/core";

const initUser: User = {
  userId: "",
  name: "",
  deliverAuthority: false,
  adminAuthority: false,
  reportAuthority: false,
  salesOfficeAuthority: "",
  adUser: "",
};
export default defineComponent({
  name: "UserList",
  setup() {
    const { axios, error, success } = usePlugin();
    const users = ref<User[]>([]);
    const user = ref<User>(JSON.parse(JSON.stringify(initUser)));
    const showPopup = ref(false);
    const editMode = ref(false);

    const searchString = useSessionStorage("userList-searchString", "");
    const filteredUsers = computed(() => {
      if (!searchString.value) return users.value;
      const fuse = new Fuse(users.value, {
        keys: ["uesrId", "name", "adUser", "salesOfficeAuthority"],
        threshold: 0.4,
      });
      const result = fuse.search(searchString.value);
      return result.map((x) => x.item);
    });

    const isLoading = ref(false);
    const getData = async () => {
      isLoading.value = true;
      try {
        const response = await axios.post<GetUserResponse>(
          `api/v1/admin/users/get`,
          {}
        );
        users.value = response.data.users ?? [];
      } catch (e) {
        error(e);
      } finally {
        isLoading.value = false;
      }
    };

    const onEdit = (input: User) => {
      user.value = input;
      showPopup.value = true;
      editMode.value = true;
    };

    // const onDelete = (input: User) => {
    //   console.log(input);
    // };

    const onNew = () => {
      user.value = JSON.parse(JSON.stringify(initUser));
      showPopup.value = true;
      editMode.value = false;
    };

    const onSubmit = async () => {
      isLoading.value = true;
      try {
        const response = await axios.post<UpsertUserResponse>(
          `api/v1/admin/user`,
          {
            user: user.value,
          } as UpsertUserRequest
        );
        success("ทำการบันทึกข้อมูลเรียบร้อยแล้ว");
        await getData();
      } catch (e) {
        error(e);
      } finally {
        isLoading.value = false;
        showPopup.value = false;
      }
    };

    onMounted(() => {
      getData();
    });

    return {
      users,
      user,
      // onDelete,
      onEdit,
      onNew,
      showPopup,
      editMode,
      onSubmit,

      filteredUsers,
      searchString,

      isLoading,
    };
  },
});

// export interface User {
//   userId: string;
//   name: string;
//   deliverAuthority: boolean;
//   adminAuthority: boolean;
//   reportAuthority: boolean;
//   salesOfficeAuthority: string;
//   adUser: string;
// }
</script>

<style></style>
